import script from "./friendCirclePermission.vue?vue&type=script&setup=true&lang=js"
export * from "./friendCirclePermission.vue?vue&type=script&setup=true&lang=js"

import "./friendCirclePermission.vue?vue&type=style&index=0&id=2ede25fd&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/akc-mallrobot-akc-dz-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ede25fd"]])

export default __exports__